import React, { useContext, useEffect } from 'react';
import { Context } from '../../services/contexts/StateContext';
import * as S from './styles';

import { Functions } from '../Functions';

// ---------------------------------------------------
export function ListaItemBD(props) {
    const { state, dispatch } = useContext(Context);
    const { parametroInit, listaPesquisa, playmodal } = state.parametros;
    const { cliente } = state.cliente;
    const { veiculo } = state.veiculo;
    const { evento, pagamento, orcamento } = state.evento;
    const { franquia, foneCelular } = state.franquia;

    const { PesqCPFdigitando } = Functions();

    // ------------------------------
    function Func_selectItem(item) {
        // -----
        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                disabled: parametroInit.detalhesModal ? true : false,
            }
        });

        // -----
        if (props.referenciaRef === "RefClienteCPF") {
            listaPesquisa.listaCliente.map(e => (
                dispatch({
                    type: 'set_cliente',
                    payload: {
                        ...cliente,
                        id_Cliente: e._id,
                        cpfCnpj: e.cpfCnpj,
                        nome: e.nome
                    }
                })
            ))

            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    nomeItem: ""
                }
            });
        };

        // -----
        if (props.referenciaRef === "veiculoPlaca") {
            dispatch({
                type: 'set_veiculo',
                payload: {
                    ...veiculo,
                    id_Veiculo: item._id,
                    placa: item.placa,
                    modelo: item.modelo,
                    nomeCliente: item?.id_Cliente?.nome,
                    tipo: item.tipo,
                    marca: item.marca,

                }
            });

            dispatch({
                type: 'set_cliente',
                payload: {
                    ...cliente,
                    id_Cliente: item?.id_Cliente?._id,
                    nome: item?.id_Cliente?.nome,
                }
            })

            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    nomeItem: ""
                }
            });
        };

        // ----
        if (props.referenciaRef === "RefFornecedor") {
            dispatch({
                type: 'set_Evento',
                payload: {
                    ...evento,
                    id_Fornecedor: item.id,
                    fornecedor: item.nome,
                    chavePix: item.chavePix
                }
            });

            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    nomeForn: "",
                    SelectForn: item.nome,
                    id_nomeForn: props.pesqForn ? item.id : "",
                    // listaFornecedor: [],
                }
            });
        };

        // ----
        if (props.referenciaRef === "RefFranquia") {
            dispatch({
                type: 'SET_Franquia',
                payload: {
                    ...franquia,
                    id: item._id,
                    nome: item.nome,
                    cpfCnpj: item.cpfCnpj,
                    cidade: item.endereco.cidade
                }
            });

            dispatch({
                type: 'set_foneFranquia',
                payload: { 
                    ...foneCelular, 
                    numeroCel: item.foneCelular.numeroCel 
                }
            });

            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    nomeItem: "",
                    listaFranquia: [],
                }
            });
        };

        // -----
        if(props.refListaItem){
            dispatch({
                type: 'set_Pagamento',
                payload: {
                    ...pagamento,
                    nomeItem: item,
                }
            });

            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    nomeItem: "",
                }
            });
        };

        // -----
        if(props.refItemOcamento){
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    nomeItem: "",
                    selectItem: item
                }
            });

            dispatch({
                type: 'set_Orcamento',
                payload: {
                    ...orcamento,
                    selectItem: item
                }
            });
        };

        // -----
        if (playmodal.playModalCobranca) {
            const veic = listaPesquisa.listaVeiculo.filter(p => p.placa === item.nome);
            console.log(veic)
            veic.map(v => {
                dispatch({
                    type: 'set_cliente',
                    payload: {
                        ...cliente,
                        cpfCnpj: v.id_Cliente.cpfCnpj,
                        nome: v.id_Cliente.nome
                    }
                })
            })
        };
    };

    // ----------------------------
    useEffect(() => {
        if (props.referenciaRef === "RefClienteCPF") {
            if (listaPesquisa.nomeItem?.length == 11 && !cliente.id_Cliente) {
                PesqCPFdigitando(listaPesquisa.nomeItem)
            };

            if (listaPesquisa.nomeItem?.length == 14 && !cliente.id_Cliente) {
                PesqCPFdigitando(listaPesquisa.nomeItem)
            };

            if (listaPesquisa.nomeItem?.length <= 11) {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, botaoCPF: false }
                });
            };
        };
    }, [listaPesquisa.nomeItem]);

    // ---------------------------
   

    // ###############################################################
    return (
        <>
        {props.listaItem.length > 0 ?
        <S.ListaDescricao>
            {props.listaItem.map((t, key) => (
                <S.listaItemDesp key={key}>
                    <span
                    style={{ 'display': "flex", 'width': "100%", "cursor": "pointer", "color": "black", padding: "3px" }}
                    onClick={() => Func_selectItem(t)}>
                    {t.placa ? t.placa : t.nome ? t.nome : t}
                    </span>
                </S.listaItemDesp>
            ))}
        </S.ListaDescricao>
        :
        listaPesquisa.alertaNovo && props.Cadastro ?
        <S.ListaDescricao>
            <S.listaItemDesp>
                <span
                style={{ 'display': "flex", 'width': "100%", "cursor": "pointer", justifyContent: "center", "color": "red" }}
                onClick={() => props.NovoCadastro()}
                >
                    Não Encontrado.. <br />
                    Clique para Cadastrar
                </span>
            </S.listaItemDesp>
        </S.ListaDescricao>
        :
        null
        }
        </>
    )
};